import { Outlet } from 'react-router-dom';
import './App.scss';
import { PUBLIC_SWAGGER_URL } from './Configs'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

function Startup() {

    return (
        <div className="App">
            <header className="header fixed-top">
                <div className="branding docs-branding">
                    <div className="container-fluid position-relative py-2">
                        <div className="docs-logo-wrapper">

                            <button id="docs-sidebar-toggler" className="docs-sidebar-toggler docs-sidebar-visible me-2 d-xl-none" type="button">
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>

                            <div className="site-logo"><a className="navbar-brand" href="/"><img className="logo-icon me-2"
                                src="/assets/images/westpay-logo.svg" alt="logo"></img><span className="logo-text"></span></a></div>
                        </div>
                        <div className="docs-top-utilities d-flex justify-content-end align-items-center">
                            {/*
                             <div className="top-search-box d-none d-lg-flex">
                                <form className="search-form">
                                    <input type="text" placeholder="Search the docs..." name="search" className="form-control search-input"/>
                                        <button type="submit" className="btn search-btn" value="Search"><i className="fas fa-search"></i></button>
                                </form>
                            </div>
                            */}
                            <ul className="social-list list-inline mx-md-3 mx-lg-5 mb-0 d-none d-lg-flex">
                                {/* <li className="list-inline-item"><a href="https://www.westpay.se/"><i className="fab fa-github fa-fw"></i></a></li>
                                    <li className="list-inline-item"><a href="#"><i className="fab fa-twitter fa-fw"></i></a></li>
                                    <li className="list-inline-item"><a href="#"><i className="fab fa-slack fa-fw"></i></a></li>
                                    <li className="list-inline-item"><a href="#"><i className="fab fa-product-hunt fa-fw"></i></a></li> */}
                            </ul>
                            {/* <a href="simulator" target="_blank" rel="noreferrer"
                                className="btn btn-primary d-none d-lg-flex" role="button" aria-disabled="true">Simulator</a> */}
                        </div>
                    </div>
                </div>
            </header>
            <Outlet />
            <ToastContainer
                position='bottom-right'
                autoClose={5000}
            />
        </div>
    );
}

export default Startup;
